import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CommonBreadcrumb from "./../../../common_components/breadcrumb/CommonBreadcrumb";
import WhiteButton from "./../../../../components/common_components/common_button/WhiteButton";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSliders } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import History_Table from "../../history_table/History_Table";
import "./Withdraw.css";

const WalletInnerPage = () => {
  const navigate = useNavigate();

  const breadcrumbItems = [
    { label: "profile", link: "/profile" },
    { label: "Withdraw" },
  ];

  return (
    <section className="wallet-inner-page withdraw-section">
      <CommonBreadcrumb items={breadcrumbItems} />

      <Container className="wallet-container">
        <Row className="justify-content-center">
          <Col lg={7}>
            {/* Wallet Card */}
            <div className="wallet-card">
              <div className="wallet-card-left">
                <p className="wallet-label">Current Balance</p>
                <h2 className="wallet-amount">₹ 5000</h2>
                <p className="wallet-payout">
                  *Payout On: 1st Day Of Every Month
                </p>
              </div>

              <div className="wallet-card-right">
                <img src="images/profile/wallet.png" alt="wallet" />
              </div>
            </div>

            {/* Add Bank Section */}
            <div className="withdraw-add-bank-section">
              <div className="withdraw-payout-section">
                {/* Header */}
                <div className="withdraw-payout-header">
                  <h6>Payout Money to</h6>
                  <WhiteButton
                    title="Update Account"
                    className="withdraw-update-account"
                    bg="#fff"
                    color="#000"
                    hoverColor="#000"
                    hoverBg="#fff"
                    style={{ border: "1px solid #000", borderRadius: "20px" }}
                    onClick={() => navigate("/update-bank-details")}
                  />
                </div>

                {/* Bank Card */}
                <div className="withdraw-bank-card">
                  <div className="withdraw-bank-icon">
                    <i className="fa-solid fa-building-columns"></i>
                  </div>

                  <div className="withdraw-bank-details">
                    <p className="withdraw-bank-title">Primary Bank Account</p>
                    <h5>76*******930</h5>
                  </div>
                </div>

                {/* Amount Section */}
                <div className="withdraw-amount-section">
                  <div className="withdraw-amount-input">
                    <span>₹</span>
                    <input type="text" placeholder="Enter Amount" />
                  </div>

                  <p className="withdraw-note">
                    Your balance must be at least ₹500 to request a Payouts.
                  </p>
                </div>
              </div>

              <div className="withdraw-payout-button">
                <WhiteButton
                  title="Payouts"
                  bg="#000"
                  color="#f35f37"
                  hoverColor="#f35f37"
                  hoverBg="#000"
                  onClick={() => navigate("/payment-payout")}
                />
              </div>
            </div>

            <History_Table />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WalletInnerPage;
